/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/



const GuardedSignUpRoute = ({ children }) => { 

    return process.env.REACT_APP_REGISTER_MODE === "true" ? children : null;
}
export default GuardedSignUpRoute;